import React, { useState, useContext, useEffect } from 'react';
import { QueryContext } from '../../../hooks/Contexts';
import { sortByAlpha, sortable } from '../../../helpers/sorters';

export const OptionFilterDropdown = ({
  field,
  filtering,
  setFiltering,
  handleFilter,
  removeFilter,
  setSelecting,
  selecting,
}) => {
  const { queryParams } = useContext(QueryContext);
  const [optionsFiltered, setOptionsFiltered] = useState(
    queryParams.filters[field.id] || []
  );

  useEffect(() => {
    const dropdownElement = document.getElementById(field.id + '-dropdown');
    const onClickOutsideDropdown = (e) => {
      if (
        dropdownElement &&
        !dropdownElement.contains(e.target) &&
        e.target.className != 'fa-solid fa-search fa-rotate-90'
      ) {
        setSelecting(false);
      }
    };
    if (selecting) {
      document.addEventListener('click', onClickOutsideDropdown);
    }
    return () => document.removeEventListener('click', onClickOutsideDropdown);
  }, [selecting]);

  function handleOptionToggle(e) {
    let optionId = e.target.id.split('.')[0];
    if (optionsFiltered.includes(optionId)) {
      setOptionsFiltered((opts) => {
        return opts.filter((o) => o != optionId);
      });
    } else {
      setOptionsFiltered((opts) => {
        return [...opts, optionId];
      });
    }
  }

  function handleApplyFilter(e) {
    handleFilter(field.id, optionsFiltered);
    setFiltering(true);
    setSelecting(false);
  }

  function handleClearFilter(e) {
    removeFilter(field.id);
    setFiltering(false);
    setSelecting(false);
  }

  const sortedOptions = field.alpha
    ? sortByAlpha(field.options, 'name')
    : sortable(field.options);

  return (
    <div className='dropdown' id={field.id + '-dropdown'}>
      <ol>
        {sortedOptions.map((option) => {
          return (
            <li key={option.id}>
              <a
                className={
                  optionsFiltered.includes(option.id.toString())
                    ? 'checked'
                    : ''
                }
                id={option.id + '.filter'}
                onClick={handleOptionToggle}
              >
                {option.name}
              </a>
            </li>
          );
        })}

        <li>
          <a
            className={optionsFiltered.includes('0') ? 'checked' : ''}
            onClick={handleOptionToggle}
            id={'0' + '.' + field.id}
          >
            (Blanks)
          </a>
        </li>
      </ol>

      <div className='controls'>
        {filtering && <button onClick={handleClearFilter}>Clear Filter</button>}
        <button onClick={handleApplyFilter}>Apply</button>
      </div>
    </div>
  );
};
